const API_BASE_URL =
  process.env.REACT_APP_CONSUMER_API_URL + '/api/CheckoutApi';

/**
 * Service for managing room reservations through the backend checkout API.
 *
 * Provides methods to create and clear room reservations for a given room/user pair.
 */
const ReservationService = {
  /**
   * Creates a room reservation.
   *
   * @param {string|number} rsItemId
   * @param {string|number} userId
   * @returns {Promise<{success: boolean, data?: any, error?: any}>}
   */
  makeRoomReservation: async (rsItemId, userId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/make-room-reservation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ roomId: rsItemId, userId }),
      });

      if (!response.ok) {
        return { success: false };
      }

      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      return { success: false, error };
    }
  },

    /**
   * Clears a room reservation.
   *
   * @param {string|number} rsItemId
   * @param {string|number} userId
   * @returns {Promise<{success: boolean, data?: any, error?: any}>}
   */
  clearRoomReservation: async (rsItemId, userId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/clear-room-reservation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ roomId: rsItemId, userId }),
      });

      if (!response.ok) {
        return { success: false };
      }

      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      return { success: false, error };
    }
  },
};

export default ReservationService;
